<div class="ads-page">

  <p-toast position="top-right" />

  <!-- En-tête ──────────────────────────────────────────────────────────────── -->
  <div class="page-top">
    <div>
      <h1 class="page-title">Publicités</h1>
      <p class="page-subtitle">Revue et validation des campagnes publicitaires payantes</p>
    </div>
    @if (!loadingAll() && !loadingPending()) {
      <div class="kpi-chips">
        <span class="kpi-chip kpi-total">
          <i class="pi pi-megaphone"></i>
          {{ pageAll().totalElements }} publicité{{ pageAll().totalElements > 1 ? 's' : '' }}
        </span>
        <span class="kpi-chip kpi-pending">
          <i class="pi pi-clock"></i>
          {{ pagePending().totalElements }} en attente
        </span>
      </div>
    }
  </div>

  <!-- Onglets ──────────────────────────────────────────────────────────────── -->
  <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)" class="ads-tabs">
    <p-tablist>
      <p-tab value="0">
        <i class="pi pi-hourglass tab-icon"></i>
        En attente
        @if (pagePending().totalElements > 0) {
          <span class="tab-badge tab-badge--warn">{{ pagePending().totalElements }}</span>
        }
      </p-tab>
      <p-tab value="1">
        <i class="pi pi-megaphone tab-icon"></i>
        Toutes
        <span class="tab-badge">{{ pageAll().totalElements }}</span>
      </p-tab>
    </p-tablist>

    <p-tabpanels>

      <!-- Panel 1 : En attente ─────────────────────────────────────────── -->
      <p-tabpanel value="0">
        <div class="table-wrap">
          <p-table [value]="pagePending().content" [lazy]="true" (onLazyLoad)="onLazyPending($event)"
                   [paginator]="true" [rows]="20" [totalRecords]="pagePending().totalElements"
                   [rowsPerPageOptions]="[10,20,50]" [loading]="loadingPending()" [rowHover]="true"
                   paginatorDropdownAppendTo="body"
                   styleClass="ads-table" [showCurrentPageReport]="true"
                   currentPageReportTemplate="{first} - {last} sur {totalRecords}">
            <ng-template #header>
              <tr>
                <th></th>
                <th>Publicité</th>
                <th>Annonceur</th>
                <th>Package</th>
                <th>Prix</th>
                <th>Paiement</th>
                <th>Soumise le</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-ad>
              <tr class="ad-row--urgent">
                <td class="cell-thumb">
                  @if (imageUrls()[ad.id]) {
                    <img [src]="imageUrls()[ad.id]" [alt]="ad.title" class="ad-thumb" />
                  } @else {
                    <div class="ad-thumb ad-thumb--placeholder"><i class="pi pi-image"></i></div>
                  }
                </td>
                <td class="cell-main">
                  <div class="ad-title">{{ ad.title }}</div>
                  <div class="ad-placements"><i class="pi pi-map-marker"></i>{{ placementsLabel(ad.placements) }}</div>
                </td>
                <td class="cell-advertiser">
                  <div class="advertiser-name">{{ ad.advertiserCompanyName || '—' }}</div>
                  <div class="advertiser-contact">{{ ad.advertiserContactEmail || ad.advertiserContactPhone || '—' }}</div>
                </td>
                <td><span class="chip-package">{{ ad.packageName || ad.packageCode }}</span></td>
                <td class="cell-price">{{ ad.priceAmount | fcfa }}</td>
                <td><app-status-tag [label]="paymentLabel(ad.paymentStatus)" [severity]="paymentSeverity(ad.paymentStatus)" /></td>
                <td class="cell-date">{{ formatDate(ad.createdAt) }}</td>
                <td class="cell-action">
                  @if (authService.hasPermission('ADS_MODERATE')) {
                    <button pButton [disabled]="!canValidate(ad) || processing() === ad.id" [loading]="processing() === ad.id"
                            [pTooltip]="canValidate(ad) ? 'Publier cette annonce' : 'Paiement non finalisé — validation impossible'"
                            class="btn-validate" (click)="validate(ad)" icon="pi pi-check-circle" label="Valider"></button>
                    <button pButton severity="danger" [outlined]="true" class="btn-reject"
                            [disabled]="!canReject(ad) || processing() === ad.id"
                            (click)="startReject(ad)" icon="pi pi-times-circle" label="Rejeter"></button>
                  }
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="8">
                  <app-empty-state icon="pi-check-circle" iconVariant="success"
                                    title="Aucune publicité en attente"
                                    message="Toutes les campagnes soumises ont été traitées." />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-tabpanel>

      <!-- Panel 2 : Toutes ─────────────────────────────────────────────── -->
      <p-tabpanel value="1">
        <div class="table-wrap">
          <p-table [value]="pageAll().content" [lazy]="true" (onLazyLoad)="onLazyAll($event)"
                   [paginator]="true" [rows]="20" [totalRecords]="pageAll().totalElements"
                   [rowsPerPageOptions]="[10,20,50]" [loading]="loadingAll()" [rowHover]="true"
                   paginatorDropdownAppendTo="body"
                   styleClass="ads-table" [showCurrentPageReport]="true"
                   currentPageReportTemplate="{first} - {last} sur {totalRecords}">
            <ng-template #header>
              <tr>
                <th></th>
                <th>Publicité</th>
                <th>Annonceur</th>
                <th>Package</th>
                <th>Prix</th>
                <th>Statut</th>
                <th>Paiement</th>
                <th>Campagne</th>
                <th>Créée le</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-ad>
              <tr>
                <td class="cell-thumb">
                  @if (imageUrls()[ad.id]) {
                    <img [src]="imageUrls()[ad.id]" [alt]="ad.title" class="ad-thumb" />
                  } @else {
                    <div class="ad-thumb ad-thumb--placeholder"><i class="pi pi-image"></i></div>
                  }
                </td>
                <td class="cell-main">
                  <div class="ad-title">{{ ad.title }}</div>
                  <div class="ad-placements"><i class="pi pi-map-marker"></i>{{ placementsLabel(ad.placements) }}</div>
                </td>
                <td class="cell-advertiser">
                  <div class="advertiser-name">{{ ad.advertiserCompanyName || '—' }}</div>
                  <div class="advertiser-contact">{{ ad.advertiserContactEmail || ad.advertiserContactPhone || '—' }}</div>
                </td>
                <td><span class="chip-package">{{ ad.packageName || ad.packageCode }}</span></td>
                <td class="cell-price">{{ ad.priceAmount | fcfa }}</td>
                <td><app-status-tag [label]="statusLabel(ad.status)" [severity]="statusSeverity(ad.status)" /></td>
                <td><app-status-tag [label]="paymentLabel(ad.paymentStatus)" [severity]="paymentSeverity(ad.paymentStatus)" /></td>
                <td class="cell-date">
                  @if (ad.startDate) {
                    {{ formatDate(ad.startDate) }} → {{ formatDate(ad.endDate) }}
                  } @else {
                    —
                  }
                </td>
                <td class="cell-date">{{ formatDate(ad.createdAt) }}</td>
                <td class="cell-action">
                  @if (ad.status === 'PENDING_REVIEW' && authService.hasPermission('ADS_MODERATE')) {
                    <button pButton [disabled]="!canValidate(ad) || processing() === ad.id" [loading]="processing() === ad.id"
                            [pTooltip]="canValidate(ad) ? 'Publier cette annonce' : 'Paiement non finalisé — validation impossible'"
                            class="btn-validate" (click)="validate(ad)" icon="pi pi-check-circle" label="Valider"></button>
                    <button pButton severity="danger" [outlined]="true" class="btn-reject"
                            [disabled]="processing() === ad.id"
                            (click)="startReject(ad)" icon="pi pi-times-circle" label="Rejeter"></button>
                  }
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="10">
                  <app-empty-state icon="pi-megaphone" title="Aucune publicité"
                                    message="Les campagnes soumises par les annonceurs apparaîtront ici." />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-tabpanel>

    </p-tabpanels>
  </p-tabs>

  <!-- Dialogue de rejet ────────────────────────────────────────────────────── -->
  <app-reject-ad-dialog [(visible)]="rejectDialogVisible" [(text)]="rejectText"
                         [loading]="processing() === rejectTarget()?.id"
                         (confirm)="confirmReject()" (cancel)="cancelReject()" />

</div>
